export default {"src":"/_next/static/media/30_back.0fbc8878.svg","height":384,"width":450,"blurWidth":0,"blurHeight":0};